import React from 'react';
import {createRoot} from 'react-dom/client';
import JshModule from '@core/scripts/helper/jsh-module';

import Header from '@header/scripts/components/Header.jsx';
import HeaderModel from '@header/scripts/models/header-model.js';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {persistQueryClient} from '@tanstack/react-query-persist-client';
import {HeaderProvider} from '@header/scripts/components/context/HeaderContext.jsx';
import {createAsyncStoragePersister} from '@tanstack/query-async-storage-persister';

const {moduleScope, config} = JshModule('header-new');

const {
    currentPage,
    deviceType,
    currentShopId,
    cartUrl,
    cartTitle,
    searchUrl,
    searchNoResultsFound,
    rootUrl,
    lightColorScheme,
    transparentHeader,
} = config;

const cart = {
    title: cartTitle,
    url: cartUrl,
};

const search = {
    url: searchUrl,
    noResultsFound: searchNoResultsFound,
};

const headerModel = HeaderModel.load();

const queryClient = new QueryClient();

const sessionStoragePersister = createAsyncStoragePersister({
    storage: window.sessionStorage,
    key: 'BONPRIX_HEADER_QUERY_CLIENT',
});
persistQueryClient({
    queryClient,
    persister: sessionStoragePersister,
});

createRoot(moduleScope).render(
    <QueryClientProvider client={queryClient}>
        <HeaderProvider
            isTransparent={transparentHeader === 'true'}
            lightMode={lightColorScheme === 'true'}
            headerWrapper={moduleScope}
        >
            <Header
                moduleScope={moduleScope}
                wishlist={headerModel.wishlistModel}
                cart={cart}
                navigation={headerModel.navigationModel}
                notifications={headerModel.notificationsModel}
                deviceType={deviceType}
                currentPage={currentPage}
                currentShopId={currentShopId}
                user={headerModel.userModel}
                search={search}
                rootUrl={rootUrl}
            />
        </HeaderProvider>
    </QueryClientProvider>,
);
